import { useDispatch, useSelector } from 'react-redux';
import { WebCommandEnum } from '../models/commands';
import { getAssetList, setForceReload } from '~/domain/inventory-list/store/asset-list-reducer';
import { useInventoryV2ListEnabled } from '~/domain/inventory-v2/hooks/use-inventory-v2-list-enabled';
import { AppState } from '~/reducers';
import type { AppDispatch } from '~/store/Store';
import { closeModal } from '~/domain/add-asset/store/add-asset-reducer';
import { useConsumeWebCommand } from './use-consume-web-command';

const useAssetListUpdate = () => {
  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  const dispatch = useDispatch<AppDispatch>();
  const { enabled: pagedListEnabled, isLoaded, timedOut } = useInventoryV2ListEnabled();

  useConsumeWebCommand(
    WebCommandEnum.RefreshInventory,
    () => {
      dispatch(closeModal());
      if (pagedListEnabled) {
        dispatch(setForceReload());
      } else {
        void dispatch(getAssetList(true));
      }
    },
    { enabled: !!onWebView && (isLoaded || timedOut) }
  );
};
export { useAssetListUpdate };
